/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：320
 */

module.exports = {
  wrapper: "ZoomBox_wrapper__2CMDz",
  undoRedoWrapper: "ZoomBox_undoRedoWrapper__sqYcD",
  zoomWrapper: "ZoomBox_zoomWrapper__u-SDs",
  cleanUpWrapper: "ZoomBox_cleanUpWrapper__13NlT",
  percent: "ZoomBox_percent__3PBtm",
  iconWrapper: "ZoomBox_iconWrapper__3iz-3",
  disable: "ZoomBox_disable__3hmXf",
  redo: "ZoomBox_redo__1BXVG"
}
